<div class="container">
    @if(language == "fr-FR") {
    <h2>Bienvenue sur la nouvelle interface Unifield !</h2>
    <p>Nous avons mis à jour Unifield pour vous offrir une expérience plus fluide et agréable. Voici ce qui change :</p>
    <ul>
        <li>
            <strong>Performance améliorée</strong> : navigation plus rapide et traitement des données optimisé.
        </li>
        <li>
            <strong>Nouvelle expérience visuelle</strong> : interface modernisée, plus claire et intuitive.
        </li>
        <li>
            <strong>Navigation simplifiée</strong> : accès aux fonctionnalités clés plus direct et efficace.
        </li>
    </ul>
    <p>L'ancienne version reste disponible jusqu'à fin janvier sur <a
            href="https://web-v1.prod.cad42.com">web‑v1.prod.cad42.com</a>.</p>
    <p>Et ce n'est que le début ! D'autres améliorations, centrées sur l'ergonomie, sont actuellement en cours pour
        rendre votre utilisation de Unifield encore plus intuitive.</p>

    <p><strong>Merci pour votre confiance,</strong><br>
        <i>L'équipe CAD.42</i>
    </p>
    }
    @if(language == "en-US") {
    <h2>Welcome to the new Unifield interface!</h2>
    <p>We have updated Unifield to provide you with a smoother and more enjoyable experience. Here’s what’s new:</p>
    <ul>
        <li>
            <strong>Improved performance</strong>: faster navigation and optimized data processing.
        </li>
        <li>
            <strong>New visual experience</strong>: a modernized interface that is clearer and more intuitive.
        </li>
        <li>
            <strong>Simplified navigation</strong>: quicker and more efficient access to key features.
        </li>
    </ul>
    <p>The previous application remains available for your use at
        <a href="https://web-v1.prod.cad42.com">web-v1.prod.cad42.com</a>.
    </p>
    <p>And this is just the beginning! More improvements, focused on usability, are currently underway to make your
        Unifield experience even more intuitive.</p>

    <p><strong>Thank you for your trust,</strong><br>
        <i>The CAD.42 team</i>
    </p>
    }
</div>
<div class="confirm">
    <lib-button color="success" (click)="confirm()" size="large" [text]="'form.continue' | translate"></lib-button>
</div>